module.exports = __webpack_public_path__ + "img/20190926152800651.93f23400.jpg";